import { AnimatePresence } from 'motion/react';
import * as motion from 'motion/react-m';
import type { FC } from 'react';
import { IconComponent } from '@/components/IconComponent';
import { useToggle } from '@/hooks/common';
import { ScTermsAndConditions } from './styled';

interface TermsProps {
  title: string;
  content: string[];
}

export const Terms: FC<TermsProps> = ({ title, content }) => {
  const [isTermsAndConditionsOpen, toggleTermsAndConditionsOpen] =
    useToggle(false);

  return (
    <ScTermsAndConditions isOpen={isTermsAndConditionsOpen}>
      <div className="title" onClick={toggleTermsAndConditionsOpen}>
        {title}
        <div className="arrow">
          <IconComponent name="whiteArrowRight" size="18px" />
        </div>
      </div>
      <AnimatePresence>
        <div className="points">
          {isTermsAndConditionsOpen && (
            <motion.div
              animate={{ opacity: 1, rotateX: -15 }}
              exit={{ opacity: 0, rotateX: 0 }}
              initial={{ opacity: 0, rotateX: 0 }}
              transition={{ duration: 0.25 }}
            >
              {content.map((text, i) => (
                <p key={i}>{text}</p>
              ))}
            </motion.div>
          )}
        </div>
      </AnimatePresence>
    </ScTermsAndConditions>
  );
};
